export const BILLS_INCLUDED_VALUES = { all: 'all', some: 'some', none: 'none' };

export const PAYMENT_METHODS = [
  { filename: 'paypal-logo.svg', name: 'PayPal' },
  { filename: 'visa-logo.svg', name: 'Visa' },
  { filename: 'mastercard-logo.svg', name: 'Mastercard' },
  { filename: 'americanexpress-logo.svg', name: 'American Express' },
  { filename: 'unionpay-logo.svg', name: 'UnionPay' }
];

export const FILES_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
